import React from 'react';
import { ISmartProps } from './types';
import { StatefulButtonGroupProps as _StatefulButtonGroupProps } from 'baseui/button-group';
import { View } from './view';
import { StatefulView } from './viewStateful';

export type ButtonGroupProps = Omit<ISmartProps, 'css'>;
export const ButtonGroup = React.forwardRef((props: ISmartProps, ref: any) => {
	return <View {...props} />;
});

export type StatefulButtonGroupProps = ISmartProps & { mode: 'radio' | 'checkbox', initialState: { selected: number } } &
	Omit<Omit<_StatefulButtonGroupProps, 'kind'>, 'children'>;

export const StatefulButtonGroup = (props: StatefulButtonGroupProps) => {
	return <StatefulView {...props} />;
};